import Animate from "../partials/animate";

export default class RecipeContent {
    constructor($wrapper) {
        this.$trigger = $wrapper.querySelector('[data-collapsible-trigger]');
        this.$labelShow = $wrapper.querySelector('[data-collapsible-label-show]');
        this.$labelHide= $wrapper.querySelector('[data-collapsible-label-hide]');
        this.$body = $wrapper.querySelector('[data-collapsible-body]');
        this.$bodyWrapper = $wrapper.querySelector('[data-collapsible-body-wrapper]');

        if(this.$body.offsetHeight <= 500) {
            this.$trigger.classList.add('d-none');
            this.$bodyWrapper.classList.add('recipe-content--active');
        }

        this.toggle = this.toggle.bind(this);
        this.setBodyMaxHeight = this.setBodyMaxHeight.bind(this);

        this.setBodyMaxHeight();
        window.addEventListener('resize', this.setBodyMaxHeight);

        this.$trigger.addEventListener('click', this.toggle);
    }

    setBodyMaxHeight() {
        this.$bodyWrapper.style.setProperty('--max-height', this.$body.offsetHeight + 'px');
    }

    toggle(e) {
        e.preventDefault();

        this.$trigger.classList.toggle('recipe-content__trigger--active');
        this.$bodyWrapper.classList.toggle('recipe-content--active');
        this.$labelShow.classList.toggle('d-none');
        this.$labelHide.classList.toggle('d-none');
    }
}
